class DateTimeUtils {
    secondsToMilliseconds(seconds: number) : number {
        return seconds * 1000;
    }

    minutesToMilliseconds(minutes: number) : number {
        return this.secondsToMilliseconds(minutes * 60);
    }

    millisecondsToSeconds(milliseconds: number) : number {
        return milliseconds / 1000;
    }
}

export default new DateTimeUtils();